/* iPhone model comparison picker.
   Reads window.PF_IPHONE_MODELS (from sections/iphone-compare.liquid), renders up to 2 columns
   on mobile / 3 on desktop, supports per-column model swap, add/remove, ?models= URL sync, and
   live price + in-stock/out-of-stock from each model's linked_product.
   Server-rendered markup is the SEO/no-JS fallback; this script re-renders on load. */
(function () {
  var MODELS = window.PF_IPHONE_MODELS || [];
  var root = document.getElementById('IphoneCompare');
  if (!root || !MODELS.length) return;

  var byHandle = {};
  MODELS.forEach(function (m) { byHandle[m.handle] = m; });

  var MOBILE_MAX = 2;
  var DESKTOP_MAX = 3;
  function maxCols() { return window.matchMedia('(max-width: 767px)').matches ? MOBILE_MAX : DESKTOP_MAX; }

  var PROMISE = [
    ['Inspection', '90+ Point Inspection'],
    ['Warranty', '12-Month Plug Warranty'],
    ['Returns', '30-Day Love It or Return It'],
    ['Shipping', 'Free 2-day shipping'],
    ['Battery health', '80%+ guaranteed']
  ];
  var SPECS = [
    ['Chip', 'chip_name'],
    ['Display', 'display_spec'],
    ['Battery', 'battery_spec'],
    ['Main camera', 'camera_main'],
    ['Ultra-wide', 'camera_ultra'],
    ['Telephoto', 'camera_tele'],
    ['Storage', 'storage_options'],
    ['Colors', 'colors_available']
  ];
  var CHECK = '<svg class="iphone-compare__check" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M13.5 4.5 6.5 11.5 3 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var current = [];

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = (s == null ? '' : String(s));
    return d.innerHTML;
  }

  function getHandlesFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search).get('models');
      if (!p) return null;
      var arr = p.split(',').map(function (s) { return s.trim(); }).filter(function (h) { return byHandle[h]; });
      return arr.length ? arr : null;
    } catch (e) { return null; }
  }

  function setUrl(handles) {
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('models', handles.join(','));
      history.replaceState({}, '', u);
    } catch (e) {}
  }

  function optionList(selected) {
    return MODELS.map(function (m) {
      return '<option value="' + esc(m.handle) + '"' + (m.handle === selected ? ' selected' : '') + '>' + esc(m.name) + '</option>';
    }).join('');
  }

  function priceBlock(m) {
    if (!m.priceMoney) return '';
    var html = '<div class="iphone-compare__price">From ' + esc(m.priceMoney) + '</div>';
    if (m.msrp && m.priceCents && (m.msrp * 100 > m.priceCents)) {
      html += '<div class="iphone-compare__save">Save $' + Math.round(m.msrp - m.priceCents / 100) + ' vs new</div>';
    }
    html += m.available
      ? '<div class="iphone-compare__stock iphone-compare__stock--in">In stock</div>'
      : '<div class="iphone-compare__stock iphone-compare__stock--out">Out of stock</div>';
    return html;
  }

  function shopBlock(m) {
    if (m.priceMoney && !m.available) {
      return '<a class="button button--secondary" href="' + esc(m.seriesUrl || m.buyUrl || '#') + '">See options</a>';
    }
    return '<a class="button button--primary" href="' + esc(m.buyUrl || '#') + '">Shop</a>';
  }

  function colHead(handle, idx) {
    var m = byHandle[handle];
    if (!m) return '';
    var hasImg = m.image && m.image.indexOf('no-image') === -1;
    var media = hasImg
      ? '<div class="iphone-compare__media"><img src="' + esc(m.image) + '" alt="' + esc(m.name) + '" loading="lazy"></div>'
      : '<div class="iphone-compare__media iphone-compare__media--placeholder">' + esc(m.name) + '</div>';
    var remove = idx >= 2 ? '<button type="button" class="iphone-compare__col-remove" data-remove="' + idx + '">Remove</button>' : '';
    return '<div class="iphone-compare__col-head" data-col="' + idx + '">' +
      '<select class="iphone-compare__select" data-select="' + idx + '" aria-label="Choose a model to compare">' + optionList(handle) + '</select>' +
      media +
      '<p class="iphone-compare__model-name">' + esc(m.name) + '</p>' +
      '<span class="iphone-compare__model-series">' + esc(m.series || '') + '</span>' +
      priceBlock(m) +
      shopBlock(m) +
      remove +
      '</div>';
  }

  function isMobile() { return window.matchMedia('(max-width: 767px)').matches; }
  function shortName(m) { return (m && m.name ? m.name : '').replace(/^iPhone\s*/i, ''); }

  function render(handles) {
    current = handles.slice();
    if (isMobile()) { renderMobile(handles); } else { renderGrid(handles); }
    bind();
    syncAdd();
    buildFloat(handles);
    onScrollFloat();
  }

  /* ---- floating (sticky) column header, Apple-style ---- */
  var siteHeader = document.querySelector('sticky-header, .shopify-section-header, #shopify-section-header');
  function floatTop() {
    if (siteHeader) {
      var b = siteHeader.getBoundingClientRect().bottom;
      if (b > 0 && b < 240) return Math.round(b);
    }
    return 0;
  }

  function buildFloat(handles) {
    var fb = document.getElementById('IphoneCompareFloat');
    if (!fb) return;
    var cells = isMobile() ? '' : '<div class="iphone-compare__floatbar-cell iphone-compare__floatbar-cell--label"></div>';
    handles.forEach(function (h) {
      var m = byHandle[h];
      if (!m) return;
      var buy = (m.priceMoney && !m.available)
        ? '<a class="button button--secondary" href="' + esc(m.seriesUrl || m.buyUrl || '#') + '">Options</a>'
        : '<a class="button button--primary" href="' + esc(m.buyUrl || '#') + '">Shop</a>';
      var price = m.priceMoney ? '<span class="iphone-compare__floatbar-price">From ' + esc(m.priceMoney) + '</span>' : '';
      var hasImg = m.image && m.image.indexOf('no-image') === -1;
      var thumb = hasImg ? '<img class="iphone-compare__floatbar-img" src="' + esc(m.image) + '" alt="" loading="lazy">' : '';
      cells += '<div class="iphone-compare__floatbar-cell">' +
        '<span class="iphone-compare__floatbar-id">' + thumb +
          '<span class="iphone-compare__floatbar-meta"><span class="iphone-compare__floatbar-name">' + esc(m.name) + '</span>' + price + '</span>' +
        '</span>' +
        buy + '</div>';
    });
    fb.innerHTML = '<div class="iphone-compare__floatbar-grid">' + cells + '</div>';
    positionFloat();
  }

  function positionFloat() {
    var fb = document.getElementById('IphoneCompareFloat');
    if (!fb) return;
    var r = root.getBoundingClientRect();
    fb.style.left = r.left + 'px';
    fb.style.width = r.width + 'px';
    var grid = fb.querySelector('.iphone-compare__floatbar-grid');
    if (grid) {
      grid.style.gridTemplateColumns = isMobile()
        ? 'repeat(' + (current.length || 1) + ', minmax(0, 1fr))'
        : getComputedStyle(root).gridTemplateColumns;
    }
  }

  var floatRaf = false;
  function onScrollFloat() {
    if (floatRaf) return;
    floatRaf = true;
    requestAnimationFrame(function () {
      floatRaf = false;
      var fb = document.getElementById('IphoneCompareFloat');
      if (!fb) return;
      var top = floatTop();
      fb.style.top = top + 'px';
      var r = root.getBoundingClientRect();
      var headerEl = root.querySelector('.iphone-compare__col-head[data-col], .iphone-compare__m-card');
      var headerBottom = headerEl ? headerEl.getBoundingClientRect().bottom : r.top;
      var show = headerBottom < top + 4 && r.bottom > top + 60;
      if (show) positionFloat();
      fb.classList.toggle('is-visible', show);
    });
  }

  function renderGrid(handles) {
    root.className = 'iphone-compare__grid';
    root.style.setProperty('--cols', handles.length);

    var html = '<div class="iphone-compare__col-head iphone-compare__col-head--label"></div>';
    handles.forEach(function (h, i) { html += colHead(h, i); });

    html += '<div class="iphone-compare__group">Key specs</div>';
    SPECS.forEach(function (row) {
      html += '<div class="iphone-compare__label">' + esc(row[0]) + '</div>';
      handles.forEach(function (h) {
        var m = byHandle[h];
        var v = m && m[row[1]] ? m[row[1]] : '—';
        html += '<div class="iphone-compare__cell">' + esc(v) + '</div>';
      });
    });

    html += '<div class="iphone-compare__group">The Plug Promise</div>';
    PROMISE.forEach(function (row) {
      html += '<div class="iphone-compare__label">' + esc(row[0]) + '</div>';
      handles.forEach(function () {
        html += '<div class="iphone-compare__cell iphone-compare__cell--verified">' + CHECK + '<span>' + esc(row[1]) + '</span></div>';
      });
    });

    root.innerHTML = html;
  }

  function mCard(handle, idx) {
    var m = byHandle[handle];
    if (!m) return '';
    var hasImg = m.image && m.image.indexOf('no-image') === -1;
    var thumb = hasImg
      ? '<div class="iphone-compare__m-thumb"><img src="' + esc(m.image) + '" alt="' + esc(m.name) + '" loading="lazy"></div>'
      : '<div class="iphone-compare__m-thumb iphone-compare__media--placeholder">' + esc(m.name) + '</div>';
    return '<div class="iphone-compare__m-card">' +
      '<select class="iphone-compare__select" data-select="' + idx + '" aria-label="Choose a model to compare">' + optionList(handle) + '</select>' +
      '<div class="iphone-compare__m-card-main">' +
        thumb +
        '<div class="iphone-compare__m-info">' +
          '<p class="iphone-compare__model-name">' + esc(m.name) + '</p>' +
          '<span class="iphone-compare__model-series">' + esc(m.series || '') + '</span>' +
          priceBlock(m) +
        '</div>' +
      '</div>' +
      shopBlock(m) +
      '</div>';
  }

  function renderMobile(handles) {
    root.className = 'iphone-compare__mobile';
    root.style.removeProperty('--cols');

    var html = '<div class="iphone-compare__m-cards">' + handles.map(mCard).join('') + '</div>';

    html += '<div class="iphone-compare__m-section"><div class="iphone-compare__group">Key specs</div>';
    SPECS.forEach(function (row) {
      html += '<div class="iphone-compare__m-row"><div class="iphone-compare__m-rowlabel">' + esc(row[0]) + '</div>' +
        '<div class="iphone-compare__m-vals" style="--n:' + handles.length + '">' +
        handles.map(function (h) {
          var m = byHandle[h];
          var v = m && m[row[1]] ? m[row[1]] : '—';
          return '<div class="iphone-compare__m-val"><span>' + esc(v) + '</span></div>';
        }).join('') +
        '</div></div>';
    });
    html += '</div>';

    html += '<div class="iphone-compare__m-section"><div class="iphone-compare__group">The Plug Promise</div>';
    PROMISE.forEach(function (row) {
      html += '<div class="iphone-compare__m-row iphone-compare__m-row--promise">' +
        '<div class="iphone-compare__m-rowlabel">' + esc(row[0]) + '</div>' +
        '<div class="iphone-compare__m-promiseval">' + CHECK + '<span>' + esc(row[1]) + '</span></div>' +
        '</div>';
    });
    html += '</div>';

    root.innerHTML = html;
  }

  function commit() {
    setUrl(current);
    render(current.slice());
  }

  function bind() {
    root.querySelectorAll('[data-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var i = parseInt(sel.getAttribute('data-select'), 10);
        if (current.indexOf(sel.value) !== -1 && current[i] !== sel.value) {
          render(current.slice()); // ignore duplicate pick
          return;
        }
        current[i] = sel.value;
        commit();
      });
    });
    root.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (current.length <= 2) return;
        var i = parseInt(b.getAttribute('data-remove'), 10);
        current.splice(i, 1);
        commit();
      });
    });
  }

  function syncAdd() {
    var addBtn = document.getElementById('IphoneCompareAdd');
    if (!addBtn) return;
    addBtn.hidden = current.length >= maxCols() || MODELS.length <= current.length;
  }

  function firstUnused(handles) {
    for (var i = 0; i < MODELS.length; i++) {
      if (handles.indexOf(MODELS[i].handle) === -1) return MODELS[i].handle;
    }
    return null;
  }

  function init() {
    var def = (root.getAttribute('data-default-handles') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(function (h) { return byHandle[h]; });
    var handles = getHandlesFromUrl() || def;

    handles = handles.filter(function (h, i) { return handles.indexOf(h) === i; }); // de-dupe
    while (handles.length < 2) {
      var next = firstUnused(handles);
      if (!next) break;
      handles.push(next);
    }
    handles = handles.slice(0, maxCols());

    var addBtn = document.getElementById('IphoneCompareAdd');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (current.length >= maxCols()) return;
        var next = firstUnused(current);
        if (!next) return;
        current.push(next);
        commit();
      });
    }

    render(handles);

    var lastMax = maxCols();
    window.addEventListener('resize', function () {
      var max = maxCols();
      if (max === lastMax) return;
      lastMax = max;
      var next = current.slice(0, max);
      while (next.length < max) {
        var add = firstUnused(next);
        if (!add) break;
        next.push(add);
      }
      if (next.length !== current.length) { render(next); } else { positionFloat(); syncAdd(); }
    });

    window.addEventListener('scroll', onScrollFloat, { passive: true });
    window.addEventListener('resize', function () { positionFloat(); onScrollFloat(); }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
